<script setup>
import { computed } from 'vue'

const props = defineProps({
    size: {
        type: [String, Number],
        default: 56,
    },
    primaryColor: {
        type: String,
        default: '#F58145',
    },
    secondaryColor: {
        type: String,
        default: '#58A1D5',
    },
})

const outerSize = computed(() => {
    const size =
        typeof props.size === 'number' ? props.size : parseInt(props.size)
    return `${size}px`
})

const innerSize = computed(() => {
    const size =
        typeof props.size === 'number' ? props.size : parseInt(props.size)
    return `${size * 0.6}px`
})

const outerBorderWidth = computed(() => {
    const size =
        typeof props.size === 'number' ? props.size : parseInt(props.size)
    return `${Math.max(2, size * 0.107)}px`
})

const innerBorderWidth = computed(() => {
    const size =
        typeof props.size === 'number' ? props.size : parseInt(props.size)
    return `${Math.max(2, size * 0.054)}px`
})
</script>

<template>
    <div
        class="ucs-spinner"
        :style="{ width: outerSize, height: outerSize }"
    ></div>
</template>

<style scoped>
.ucs-spinner {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
}

.ucs-spinner::before,
.ucs-spinner::after {
    border-radius: 50%;
    position: absolute;
    content: '';
    display: block;
}

.ucs-spinner::before {
    border: v-bind(innerBorderWidth) solid v-bind(primaryColor);
    width: v-bind(innerSize);
    height: v-bind(innerSize);
    border-bottom-color: transparent;
    border-left-color: transparent;
    animation: ucs-spinner-rotate 0.75s infinite linear reverse;
}

.ucs-spinner::after {
    border: v-bind(outerBorderWidth) solid v-bind(secondaryColor);
    animation: ucs-spinner-rotate 0.5s infinite linear;
    height: v-bind(outerSize);
    width: v-bind(outerSize);
    border-right-color: transparent;
    border-top-color: transparent;
}

@keyframes ucs-spinner-rotate {
    to {
        transform: rotate(360deg);
    }
}
</style>
